export const WELCOME_MESSAGE = [
  'Cohorts helps you define groups of users with similar characteristics.',
  'Get started by adding a new cohort, or importing cohorts you’ve made in another environment.'
];
